import classes from '../notificationSettings.scss';
import { getLocalizedStrings } from '../../profileSettingsLocalizedStrings';
import TextBox from "./newTextBox";
import DeleteText from './deleteText';
const TextPreferences = (props) => {
  const removeIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Action_Remove.svg';
  const editIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/editIcon.svg';
  const warningIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Warning.svg';
  let strings = getLocalizedStrings('NotificationSettings');

   return(
    <div>
      {props.data.text.map((obj,index)=>(
        (index <= 2) ?
          <div>
           {((props.editButton) && (obj.encryptedvalue === props.encEditTextValue)) ?
                   <div>
                   <div className={classes.box}>
                     <span lassName={classes.textBox}>
                     <TextBox type={props.type} placeholder={props.placeHolder} maxLength={props.maxLength}
                            validator={app.appUtil.validator} textCallback={props.textCallback}   textValue={(props.newText!=="") ? props.newText : ""} />         

                       <div>{props.textPrefErr ? <div className={classes.warningBox}>  <span className={classes.warningImg}><img src={warningIcon} alt="Warning Icon" /></span> <span className={classes.warnMsg}>{strings.lessThanMsg1} {props.textData.preferenceError.join(', ')}{". "}{strings.lessThanMsg2}</span></div>:''}</div>
 
                       <span className={classes.saveCancelButtonAlign}>
                       <button className={classes.SaveButton} onClick={()=>{props.saveButtonHandler();}} disabled={props.disabledTextSave}>{strings.SaveButtonValue}</button>
                      <button className={classes.CancelButton} onClick={props.cancelButtonHandler}>{strings.CancelButtonValue}</button>
 
                       </span>
                     </span>
                     {props.textExistErrMsg ? <span className={classes.errMsg}>{props.textExistErrMsg}</span> : null}
                     
                     {props.modifyTextError ? <span className={classes.errMsg}>{strings.errorMsg}</span> : null}
                   </div>
 
 
 
                 </div>
           
           

             :
             (props.textData.removeButtonPress && obj.encryptedvalue === props.textData.removeText) ? <DeleteText text={obj.sequenceNumber} phoneNo={obj.maskedNumber} data={props.data} textData={props.textData} deleteButtonHandler={props.deleteButtonHandler} removeCancelHandler={props.removeCancelHandler} />
             :

            <div className={classes.row1}>
             <div> <button className={classes.sceImageButton} id={obj.encryptedvalue+""+strings.textEdit} onClick={(event) => props.removeHandler(event,obj.encryptedvalue)} ><img src={removeIcon} alt='Remove Icon' /> </button></div>
             <span className={classes.edititem}> {obj.maskedNumber}</span>
            <div className={classes.editButtonPadding}><button className={classes.editButton} id={obj +" "+ strings.textEdit+""+index} onClick={(event, text) => props.editHandler(event, obj.maskedNumber,obj)}  >{strings.editBtn}</button></div>

          </div> }



           
            <div className={classes.dividerLine} />

          </div> : ''))} 
    </div>
  );
};
export default TextPreferences;